import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import CustomerDetail from './CustomerDetail';

function CustomerDetailPage({ user }) {
  const { customerId } = useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Zurück zur vorherigen Seite
  };

  // Validierung nach dem Hook
  if (!user || !user.id) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Lade Benutzerdaten...</p>
      </div>
    );
  }

  if (!customerId) {
    return (
      <div className="error-container">
        <p>Fehler: Keine Kunden-ID angegeben</p>
      </div>
    );
  }

  return (
    <CustomerDetail 
      user={user} 
      customerId={customerId} 
      onBack={handleBack} 
    />
  );
}

export default CustomerDetailPage;